<template>
  <div class="">
    <table class="table my-3 table-hover table-striped table-bordered table-responsive-md table-responsive-sm">
      <thead>
      <tr>
        <th>شناسه</th>
        <th>ازطریق</th>
        <th>توضیحات</th>
        <th>اعتبار</th>
        <th>تاریخ انجام</th>
      </tr>
      </thead>

      <tr v-for="item in history">
        <th>{{ item.id }}</th>
        <th>

          <div class="" v-if=" item.chargeable_type =='order' ">
            <router-link :to="{name:'Factor',params:{orderId:item.chargeable.id}}">
              سفارش
            </router-link>
          </div>

          <div v-if=" item.chargeable_type =='user' ">
            {{ item.chargeable.name }} {{ item.chargeable.last_name }}
          </div>
          <div v-if=" item.chargeable_type ==null ">

            <p class="sms-report-button" v-b-modal="`sms-report-${item.id}`">پیامک</p>

            <b-modal :id="`sms-report-${item.id}`" size="lg" hide-footer>

              <div class="text-center" dir="rtl">
                <sms-report :sms="{id:item.chargeable_id,type:0}"/>
              </div>

            </b-modal>


          </div>

        </th>
        <th>{{ item.description }}</th>
        <th>{{ subscriptionChargeValueManager(item) }}</th>
        <th dir="ltr">{{ dateConverter(item.created_at, '/', true) }}</th>
      </tr>
    </table>

    <div class="row justify-content-center pt-3">
      <div class="mt-3 color">
        <pagination :meta="paginationMeta" :on-change-page="loadHistory"/>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "../Pagination.vue";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import SmsReport from "../Sms/SmsReport.vue";

export default {
  name: "subscriptionChargeHistory",
  components: {SmsReport, Pagination},
  props: {
    subscriptionCharge: {},
    requestType: {
      default: "normal", // normal => تاریخچه اشتراک ها در خود وبسایت رو نمایش میده  - service => تاریخچه اشتراک ماژول ها رو از سمت page-builder-service میاره.
    }
  },
  data() {
    return {
      history: [],
      paginationMeta: []
    }
  },
  methods: {
    dateConverter,
    loadHistory(page = 1) {

      let form = {
        page: page,
        subscription_charge_id: this.subscriptionCharge.id
      }

      let req;
      if (this.requestType === "service") {
        req = this.$store.dispatch('DashboardSubscription/getSubscriptionChargeHistory', form)
      } else {
        req = this.$store.dispatch('SubscriptionCharge/getSubscriptionChargeHistory', form)
      }


      req.then(res => {
        let data = res.data.data
        this.history = data.data
        this.paginationMeta = data.meta
      })

    },
    subscriptionChargeValueManager(subscriptionCharge) {
      let value = subscriptionCharge.value
      if (value.indexOf('-') > -1) {
        return dateConverter(value, '/', true)
      }
      return value
    },
  },
  mounted() {
    this.loadHistory()
  }
}
</script>

<style scoped>
.sms-report-button {
  color: #007bff;
}
</style>